import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './NoiseFilterManagerMain.css';

const NoiseFilterManagerMain = (props) => {
  return (
    <div className="manageNoiseFilterBoxLR">
      <table width="100%" border="0" cellPadding="0">
        <tbody>
          <tr>
            <td width="30%" valign="top">
              <div id="manageNoiseFilterLeft">
                <div className="noiseFilterListHeader">
                  <div className="noiseFilterListTit">NOISE FILTER LIST</div>
                  <a className="button purple_line noiseFilterAddBtn" onClick={props.handleShowAddModal}>추가</a>
                </div>
                <div className="noiseFilterListGroup">
                  <div className="overflow-component">
                    <ul>
                      {
                        props.noiseFilterArray.map((item, index) => {
                          return (
                            <li key={index} className={`category-item ${props.currentNoiseFilter.filterID === item.filterID ? 'category-item-active' : ''}`}>
                              <div onClick={() => props.selectNoiseFilter(item)}>
                                {item.category}&nbsp;&nbsp;&nbsp;
                                {item.active === 0 ? <span className="active_off">OFF</span> : <span className="active_on">ON</span>}
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </td>
            <td width="70%" valign="top">
              <div id="manageNoiseFilterRight">
                <div id="noiseFilterInfoTit">NOISE FILTER INFORMATION</div>
                {props.currentNoiseFilter.filterID ?
                  <>
                    {!props.isEditing ? (
                      <>
                        <div id="manageBtn">
                          <a className="button purple_line" onClick={props.handleActivate}>활성화</a>&nbsp;
                          <a className="button purple_line" onClick={props.handleDeactivate}>비활성화</a>&nbsp;
                          <a className="button purple_line" onClick={props.handleStartEdit}>편집</a>&nbsp;
                          <a className="button purple" onClick={props.handleDelete}>삭제</a>
                        </div>
                        <div className="noiseFilterInfo">
                          <div className="noiseFilterTypeTit">CATEGORY</div>
                          <div className="noiseFilterTypeInfo">{props.currentNoiseFilter.category}</div>
                          <div className="noiseFilterTypeTit">BASIC FILTER</div>
                          <div className="noiseFilterTypeInfo">{props.currentNoiseFilter.basicFilter}</div>
                          <div className="noiseFilterTypeTit">BOOLEAN FILTER</div>
                          <div className="noiseFilterTypeInfo">{props.currentNoiseFilter.booleanFilter}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div id="manageBtn">
                          <a className="button purple_line" onClick={props.handleSaveEdit}>저장</a>&nbsp;
                          <a className="button purple" onClick={props.handleCancelEdit}>취소</a>
                        </div>
                        <div className="noiseFilterInfo">
                          <div className="noiseFilterTypeTit">CATEGORY</div>
                          <div className="noiseFilterTypeInfo">
                            <input
                              type="text"
                              className="noiseFilterEditInput"
                              value={props.editCategory}
                              onChange={(e) => props.setEditCategory(e.target.value)}
                            />
                          </div>
                          <div className="noiseFilterTypeTit">BASIC FILTER</div>
                          <div className="noiseFilterTypeInfo">
                            <textarea
                              className="noiseFilterEditTextarea"
                              value={props.editBasicFilter}
                              onChange={(e) => props.setEditBasicFilter(e.target.value)}
                              placeholder="단어를 쉼표(,)로 구분하여 입력 (예: aaa, bbb, ccc)"
                            />
                          </div>
                          <div className="noiseFilterTypeTit">BOOLEAN FILTER (자동 변환)</div>
                          <div className="noiseFilterTypeInfo noiseFilterPreview">
                            {props.editBasicFilter
                              ? props.editBasicFilter.split(",").map(w => w.trim()).filter(w => w !== "").map(w => `! ${w}`).join(" ")
                              : ""
                            }
                          </div>
                        </div>
                      </>
                    )}
                  </>
                  : <div className="noiseFilterEmpty">필터를 선택해주세요.</div>
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* 추가 모달 */}
      <Modal show={props.showAddModal} onHide={props.handleCancelAddModal}>
        <Modal.Header closeButton>
          <Modal.Title>노이즈 필터 추가</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="noiseFilterModalField">
            <label>카테고리 (제목)</label>
            <input
              type="text"
              className="noiseFilterModalInput"
              value={props.newCategory}
              onChange={(e) => props.setNewCategory(e.target.value)}
              placeholder="필터 이름을 입력하세요"
            />
          </div>
          <div className="noiseFilterModalField">
            <label>Basic Filter</label>
            <textarea
              className="noiseFilterModalTextarea"
              value={props.newBasicFilter}
              onChange={(e) => props.setNewBasicFilter(e.target.value)}
              placeholder="단어를 쉼표(,)로 구분하여 입력 (예: aaa, bbb, ccc)"
            />
          </div>
          <div className="noiseFilterModalField">
            <label>Boolean Filter (자동 변환 미리보기)</label>
            <div className="noiseFilterPreview">
              {props.newBasicFilter
                ? props.newBasicFilter.split(",").map(w => w.trim()).filter(w => w !== "").map(w => `! ${w}`).join(" ")
                : ""
              }
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleCancelAddModal}>취소</Button>
          <Button variant="primary" onClick={props.handleAddFilter}>추가</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default NoiseFilterManagerMain;
